import { decodeBase64 } from 'helpers'

export const CLIENT_DATA = Object.freeze({
  id_br: decodeBase64('MGMzNDc1NDAtNWUwYy00N2Y3LWE3ZjQtM2I0ZWIwZmI4MjMz'),
  id_ra: decodeBase64('Y2UwOTAwODgtOTE0OC00MmUzLTk0NDctMjBkYjYwYTY2ZWYz'),
  id_mp: decodeBase64('MzQ5YTk3ZTMtNTM4Mi00NDdiLTkwODgtZDllYzE1ZGY1ZTE2'),
  id_pv: decodeBase64('NjdkMWMzMjItYTE2OS00YTdjLWE3Y2QtYWZjYWFkZjZmZTlm'),
  id_we: decodeBase64('NDEyNDc4ZmItZTFjYy00NGJmLTgwNGMtYWE5ZjcwZDg0NDdl'),
  id_md: decodeBase64('ZDlmNzk5N2EtOWY2NS00OWRiLWJhMjAtOTUzNTI1YzY5ODVm'),
})
